import React, { useCallback, useEffect, useRef, useState } from 'react'

import monofullBrandWhite from 'assets/svgs/monoful-brand-white.svg'
import { logout } from 'utils/logout'

import { COLORS } from '../../constants'
import { useUserInfo } from '../../hooks/useUserInfo'

import styles from './index.module.css'

export const AppHeader: React.FC = () => {
  const { userName } = useUserInfo()
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const menuRef = useRef<HTMLDivElement>(null)

  const toggleMenu = useCallback(() => {
    setIsMenuOpen((prev) => !prev)
  }, [])

  useEffect(() => {
    if (!isMenuOpen) return

    const handleOutsideClick = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setIsMenuOpen(false)
      }
    }

    document.addEventListener('click', handleOutsideClick)
    return () => document.removeEventListener('click', handleOutsideClick)
  }, [isMenuOpen])

  return (
    <div className={styles.bar}>
      <div className={styles.brand}>
        <img src={monofullBrandWhite} alt="hacobell brand" className={styles.logo} />
        <span className={styles.title}>トラック簿</span>
      </div>
      <div className={styles.actions}>
        <div className={styles.userMenuWrapper} ref={menuRef}>
          <button className={styles.userIconButton} onClick={toggleMenu}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="8" r="4" fill={COLORS.white} />
              <path d="M4 20c0-3.3 2.7-6 6-6h4c3.3 0 6 2.7 6 6" fill={COLORS.white} />
            </svg>
          </button>
          {isMenuOpen && (
            <div className={styles.userMenu}>
              {userName && <div className={styles.userMenuName}>{userName}</div>}
              <button className={styles.userMenuLogout} onClick={logout}>
                ログアウト
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
